import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import api from '../utility/api';
import List from '../screens/list/';
import appConstants from '../utility/app-constants';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';
import { white, green500 } from "material-ui/styles/colors";
import RaisedButton from "material-ui/RaisedButton";
import UpdateSpecialityDialog from '../screens/update-speciality';
class SpecialityList extends React.Component {

  constructor() {
    super(...arguments);
    const {defaultSort, pageSize} = this.loadUIPreferences();
    this.state = {
      specialities: [],
      sortPref: defaultSort,
      pageSize,
      updateSpecialityDialogOpen: false,
      selectedSpeciality: '',
      specialityTitle: ''
    };
  }

  componentDidMount() {
    this.getSpecialityList();
  }

  loadUIPreferences() {
    const listPreference = getListUIPreference(appConstants.LIST.SPECIALITIES);
    const defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'created_at',
          desc: true
        }
      ];
    const pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  getSpecialityList(){
    this.props.dispatch(asyncStart());
    api.getSpecialities()
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({specialities: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.SPECIALITIES);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.SPECIALITIES, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.SPECIALITIES);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.SPECIALITIES, currentPreference);
  }

  onChange(field, e, value) {
    this.setState({ [field]: value});
  }

  toggleUpdateSpeciality() {
    this.setState({updateSpecialityDialogOpen: !this.state.updateSpecialityDialogOpen});
  }

  updateSpeciality() {
    this.props.dispatch(asyncStart());

    const specialityId = this.state.selectedSpeciality.id;
    const updatedTitle = this.state.specialityTitle;

    return api.updateSpecialityInfo(specialityId, updatedTitle)
    .then((data) => {
      this.toggleUpdateSpeciality();
      this.getSpecialityList();
      this.props.dispatch(asyncEnd());
      this.props.dispatch(showFeedback({message: "Speciality updated successfully"}));
    })
    .catch(error => {
      this.props.dispatch(asyncEnd());
      this.props.dispatch(showFeedback({message: error.message}));
    })

  }

  render() {
    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false
      },
      {
        id: 'specialityTitle',
        Header: 'Title',
        accessor: d => d.speciality
      },
      {
        id: 'created_at',
        Header: 'Created',
        accessor: d => d.created_at
      },
      {
        Header: "Update",
        Cell: ({ original }) => (
          <RaisedButton
            label="Edit"
            backgroundColor={green500}
            labelColor={white}
            width="160px"
            onClick={(e) => {
              this.setState({
                updateSpecialityDialogOpen: true,
                selectedSpeciality: original,
              });
            }
          }
          /> 
          
        ),
      },


    ];

    const {specialities, pageSize, sortPref, updateSpecialityDialogOpen, selectedSpeciality, specialityTitle} = this.state;
    const {isLoading} = this.props.application;

    let reactTableProps = {
      data: specialities,
      columns,
      isLoading,
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this),
      noDataText: 'No speciality found'
    };

    return (
      <div>
        <List
          title="Speciality Category"
          addNewBtnLabel="Add New Speciality"
          listId={appConstants.LIST.SPECIALITIES}
          reactTableProps={reactTableProps}
          onCreateNew={() => hashHistory.push('create-speciality')}
        />
        <UpdateSpecialityDialog
          open={updateSpecialityDialogOpen}
          selectedSpeciality={selectedSpeciality}
          onChange={this.onChange.bind(this)}
          specialityTitle={specialityTitle}
          updateSpeciality={this.updateSpeciality.bind(this)}
          toggleUpdateSpeciality={this.toggleUpdateSpeciality.bind(this)}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(SpecialityList);


// WEBPACK FOOTER //
// ./src/containers/specialities.js